<template>
  <div class="etms-router-body">
    <el-tabs v-model="activename">
      <el-tab-pane name="version" label="版本管理">
        <div class="etms-router-search">
          <span class="etms-router-search-label fl">归属销售：</span>
          <el-select size="mini" placeholder="请选择归属销售" v-model="version.search.BindSaleman" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in enterpriseaccountlist.filter(item => item.SalemanState)" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">客户：</span>
          <el-select size="mini" placeholder="请选择客户" v-model="version.search.CustomerId" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in customerlist.filter(item=>item.BindSaleman === version.search.BindSaleman)" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">渠道：</span>
          <el-select size="mini" placeholder="请选择渠道" v-model="version.search.ChannelId" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">版本号：</span>
          <el-input size="mini" placeholder="请填写版本号搜索" v-model="version.search.VersionName" class="etms-router-search-element fl"></el-input>
          <el-tooltip class="item" content="添加" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-plus" class="etms-router-search-button fr" @click="insertVersionClick"></el-button>
          </el-tooltip>
          <el-tooltip class="item" content="搜索" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-search" class="etms-router-search-button fr" @click="searchVersionClick"></el-button>
          </el-tooltip>
          <div class="clear"></div>
        </div>
        <el-table :data="version.versionlist" :border="true" height="90%" class="etms-router-list">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="客户" prop="CustomerId" :formatter="formatterCustomerName"></el-table-column>
          <el-table-column label="渠道" prop="ChannelId" :formatter="formatterChannelName"></el-table-column>
          <el-table-column label="版本号" prop="DiscountVersionName"></el-table-column>
          <el-table-column label="生效时间段" :formatter="formatterEffectTime"></el-table-column>
          <el-table-column label="状态" prop="State" width="150px" align="center"></el-table-column>
          <el-table-column label="操作" width="150px" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" content="修改" placement="top">
                <el-button size="mini" type="primary" icon="el-icon-edit-outline" circle @click="editVersion(scope.$index,scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" content="复制" placement="top">
                <el-button size="mini" type="success" icon="el-icon-document" circle @click="copyVersion(scope.$index,scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteVersion(scope.$index,scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog :title="version.dialogInsert.dialogtitle" :visible.sync="version.dialogInsert.dialogvisible" :modal-append-to-body="false" center width="550px">
          <el-form :ref="version.dialogInsert.form.formname" :model="version.dialogInsert.form" :rules="version.dialogInsert.form.rules" label-width="100px" class="etms-dialog-form">
            <el-form-item label="客户：" prop="Customer">
              <el-select size="mini" placeholder="请选客户" v-model="version.dialogInsert.form.CustomerId" class="el-width-200" filterable>
                <el-option v-for="item in customerlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道：" prop="Channel">
              <el-select size="mini" placeholder="请选择渠道" v-model="version.dialogInsert.form.ChannelId" class="el-width-200" filterable>
                <el-option v-for="item in channellist" :key="item.value" v-model="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="价格版本：" prop="PriceVersion">
              <el-select size="mini" placeholder="请选择有效的价格版本" v-model="version.dialogInsert.form.PriceVersionId" class="el-width-200" filterable>
                <el-option v-for="item in version.priceversionlist" :key="item.value" v-model="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="版本名称：" prop="VersionName">
              <el-input size="mini" placeholder="请输入版本名称" v-model="version.dialogInsert.form.DiscountVersionName" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="生效时间：">
              <el-date-picker size="mini" v-model="version.dialogInsert.form.EffectTime" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="生效时间" end-placeholder="结束时间" :picker-options="constant.effectTimeOptions" class="el-width-300">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select size="mini" placeholder="请选择版本状态" v-model="version.dialogInsert.form.State" class="el-width-200">
                <el-option v-for="item in constant.discountVersionStates" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <div class="clear"></div>
          </el-form>
          <span class="dialog-tips">
            {{message.tips.insertDiscountTips}}
          </span>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="versionInsertSubmit">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="version.dialogCopy.dialogtitle" :visible.sync="version.dialogCopy.dialogvisible" :modal-append-to-body="false" center>
          <el-table :data="version.dialogCopy.copylist" :border="true" class="etms-router-list">
            <el-table-column label="序号" type="index" align="center"></el-table-column>
            <el-table-column label="客户" align="center">
              <template slot-scope="scope">
                <el-select size="mini" placeholder="请选择客户" v-model="scope.row.CustomerId" class="el-width-200" filterable>
                  <el-option v-for="item in customerlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="版本名" align="center">
              <template slot-scope="scope">
                <el-input size="mini" placeholder="请填写版本名称" v-model="scope.row.DiscountVersionName" class="el-width-150"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" width="50px">
              <template slot="header" slot-scope="scope">
                <el-button size="mini" icon="el-icon-plus" type="primary" circle @click="copyVersionInsert"></el-button>
              </template>
              <template slot-scope="scope">
                <el-button size="mini" icon="el-icon-delete" type="danger" circle @click="copyVersionDelete(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="versionCopySubmit">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane name="discount" label="折扣管理">
        <div class="etms-router-search">
          <span class="etms-router-search-label fl">归属销售：</span>
          <el-select size="mini" placeholder="请选择归属销售" v-model="discount.search.BindSaleman" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in enterpriseaccountlist.filter(item => item.SalemanState)" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">客户：</span>
          <el-select size="mini" placeholder="请选择客户" v-model="discount.search.CustomerId" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in customerlist.filter(item=>item.BindSaleman === discount.search.BindSaleman)" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">渠道：</span>
          <el-select size="mini" placeholder="请选择渠道" v-model="discount.search.ChannelId" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">折扣版本：</span>
          <el-select size="mini" v-model="discount.search.DiscountVersion" class="etms-router-search-element el-width-100 fl" filterable>
            <el-option v-for="item in discount.search.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">包裹分类：</span>
          <el-select size="mini" v-model="discount.search.ParcelTypeId" class="etms-router-search-element el-width-100 fl" filterable>
            <el-option v-for="item in discount.search.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">线路：</span>
          <el-select size="mini" v-model="discount.search.ChannelLineId" class="etms-router-search-element el-width-100 fl" filterable>
            <el-option v-for="item in discount.search.channellinelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <el-dropdown @command="handleCommand" class="etms-router-search-button fr">
            <el-button size="mini" type="primary">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="insertdiscount">添加折扣</el-dropdown-item>
              <el-dropdown-item command="passdiscountsetting">通折设置</el-dropdown-item>
              <el-dropdown-item command="discountbatchsetting">折扣批设</el-dropdown-item>
              <el-dropdown-item command="importdiscount">导入折扣</el-dropdown-item>
              <el-dropdown-item command="exportdiscount">导出折扣</el-dropdown-item>
              <el-dropdown-item command="deletediscount">删除折扣</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="clear"></div>
        </div>
        <table cellspacing="0" cellpadding="0" border="1" class="line-price-table">
          <tr>
            <th>起始值(不包含)</th>
            <th style="width:11%;">结束值(包含)</th>
            <th style="width:11%;">计费类型</th>
            <th style="width:11%;">起始价</th>
            <th style="width:11%;">百分比</th>
            <th style="width:11%;">值单位</th>
            <th style="width:11%;">单价</th>
            <th style="width:11%;">计算模式</th>
            <th style="width:11%;">操作</th>
          </tr>
          <template v-for="item in discount.pricelist">
            <tr :key="item.PriceTypeId" style="background-color:#DFE1E7;">
              <td colspan="9" style="color:#FF7F00;">{{item.PriceTypeName}}</td>
            </tr>
            <tr v-for="discount in item.DiscountList" :key="discount.DiscountId">
              <td>{{discount.StartValue}}</td>
              <td>{{discount.EndValue}}</td>
              <td>{{discount.DiscountBillingType}}</td>
              <td>{{discount.StartPrice}}</td>
              <td>{{discount.Percent}}</td>
              <td>{{discount.ValueUnit}}</td>
              <td>{{discount.UnitPrice}}</td>
              <td>{{discount.ManualCalcu?'手动':'自动'}}</td>
              <td>
                <el-tooltip class="item" effect="dark" content="修改" placement="top">
                  <el-button size="mini" type="primary" @click="editDiscountClick(discount)" icon="el-icon-edit-outline" circle></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <el-button size="mini" type="danger" @click="deleteDiscountClick(discount)" icon="el-icon-delete" circle></el-button>
                </el-tooltip>
              </td>
            </tr>
          </template>
          <tr style="background-color:#DFE1E7;">
            <td colspan="9" style="color:#FF7F00;">线路目的地</td>
          </tr>
          <tr>
            <td colspan="9">
              <span v-for="(item,index) in discount.search.linepurposes" :key="index" class="span-padding">{{item}}</span>
            </td>
          </tr>
        </table>
        <el-dialog :title="discount.dialogInsert.dialogtitle" :visible.sync="discount.dialogInsert.dialogvisible" :modal-append-to-body="false" center>
          <el-form :model="discount.dialogInsert.form" :rules="discount.dialogInsert.form.rules" :ref="discount.dialogInsert.form.formname" label-width="120px" class="el-form-half etms-dialog-form">
            <el-form-item label="客户：">
              <el-select size="mini" placeholder="请选择客户" v-model="discount.dialogInsert.form.CustomerId" class="el-width-200" filterable>
                <el-option v-for="item in customerlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道：">
              <el-select size="mini" placeholder="请选择渠道" v-model="discount.dialogInsert.form.ChannelId" class="el-width-200" filterable>
                <el-option v-for="item in channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="折扣版本：">
              <el-select size="mini" placeholder="请选择折扣版本" v-model="discount.dialogInsert.form.DiscountVersionId" class="el-width-200" filterable>
                <el-option v-for="item in discount.dialogInsert.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="包裹类型：">
              <el-select size="mini" placeholder="请选择包裹类型" v-model="discount.dialogInsert.form.ParcelTypeId" class="el-width-200" filterable>
                <el-option v-for="item in discount.dialogInsert.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道线路：">
              <el-select size="mini" placeholder="请选择渠道线路" v-model="discount.dialogInsert.form.ChannelLineId" class="el-width-200" filterable>
                <el-option v-for="item in discount.dialogInsert.channellinelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费用类型：">
              <el-select size="mini" placeholder="请选择费用类型" v-model="discount.dialogInsert.form.PriceTypeId" class="el-width-200" filterable>
                <el-option v-for="item in discount.dialogInsert.pricetypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="起始值(不包含)：">
              <el-input size="mini" type="number" placeholder="请填写起始值" v-model="discount.dialogInsert.form.StartValue" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="结束值(包含)：">
              <el-input size="mini" type="number" placeholder="请填写结束值" v-model="discount.dialogInsert.form.EndValue" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="计价分类：">
              <el-select size="mini" v-model="discount.dialogInsert.form.PriceBillingType" class="el-width-200" filterable @change="insertDiscountPriceTypeChange">
                <el-option v-for="item in constant.discountBillingTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="起步价：" v-show="discount.dialogInsert.form.StartPriceShow">
              <el-input size="mini" type="number" placeholder="请填写起步价" v-model="discount.dialogInsert.form.StartPrice" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="百分比：" v-show="discount.dialogInsert.form.PercentShow">
              <el-input size="mini" type="number" placeholder="百分比" v-model="discount.dialogInsert.form.Percent" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="目标计费类型：" v-show="discount.dialogInsert.form.TargetPriceTypeShow">
              <el-select size="mini" placeholder="请选择目标计费类型" v-model="discount.dialogInsert.form.TargetPriceTypeId" class="el-width-200" filterable>
                <el-option v-for="item in discount.dialogInsert.pricetypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="值单位：" v-show="discount.dialogInsert.form.ValueUnitShow">
              <el-input size="mini" type="number" placeholder="请填写值单位" v-model="discount.dialogInsert.form.ValueUnit" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="单价：" v-show="discount.dialogInsert.form.UnitPriceShow">
              <el-input size="mini" type="number" placeholder="请填写单价" v-model="discount.dialogInsert.form.UnitPrice" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="计算模式：">
              <el-checkbox v-model="discount.dialogInsert.form.ManualCalcu">手动</el-checkbox>
            </el-form-item>
            <div class="clear"></div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="dialogInsertSubmit">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="discount.dialogPass.dialogtitle" :visible.sync="discount.dialogPass.dialogvisible" :modal-append-to-body="false" center width="700px" class="etms-dialog-form">
          <el-tabs v-model="discount.dialogPass.activename">
            <el-tab-pane name="baseinfo" label="基本信息">
              <el-form :model="discount.dialogPass.form" :rules="discount.dialogPass.form.rules" label-width="100px" class="el-form-half">
                <el-form-item label="客户：">
                  <el-select size="mini" placeholder="请选择客户" v-model="discount.dialogPass.form.CustomerId" class="el-width-200" filterable>
                    <el-option v-for="item in customerlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="渠道：">
                  <el-select size="mini" placeholder="请选择渠道" v-model="discount.dialogPass.form.ChannelId" class="el-width-200" filterable>
                    <el-option v-for="item in channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="折扣版本：">
                  <el-select size="mini" v-model="discount.dialogPass.form.DiscountVersion" class="el-width-200" filterable>
                    <el-option v-for="item in discount.dialogPass.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="包裹分类：">
                  <el-select size="mini" v-model="discount.dialogPass.form.ParcelTypeIds" class="el-width-200" multiple collapse-tags filterable>
                    <el-option v-for="item in discount.dialogPass.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="线路：">
                  <el-select size="mini" v-model="discount.dialogPass.form.ChannelLineIds" class="el-width-200" multiple collapse-tags filterable>
                    <el-option v-for="item in discount.dialogPass.channellinelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <div class="clear"></div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane name="discountinfo" label="折扣信息">
              <el-table :data="discount.dialogPass.form.discountlist" :border="true" class="etms-router-list">
                <el-table-column label="序号" type="index" align="center"></el-table-column>
                <el-table-column label="起始值(不包含)">
                  <template slot-scope="scope">
                    <el-input size="mini" type="number" v-model="scope.row.StartValue" class="el-width-100"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="结束值(包含)" align="center">
                  <template slot-scope="scope">
                    <el-input size="mini" type="number" v-model="scope.row.EndValue" class="el-width-100"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="折扣(%)" align="center">
                  <template slot-scope="scope">
                    <el-input size="mini" type="number" v-model="scope.row.Percent" class="el-width-100"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center">
                  <template slot="header" slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertPassClick"></el-button>
                  </template>
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deletePassClick(scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
          <span class="dialog-tips">
            {{message.tips.passDiscountSettingTips}}
          </span>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="dialogPassSubmit">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog :title="discount.dialogBatch.dialogtitle" :visible.sync="discount.dialogBatch.dialogvisible" :modal-append-to-body="false" center width="1100px">
          <el-tabs v-model="discount.dialogBatch.activename">
            <el-tab-pane label="基本信息" name="baseinfo">
              <el-form :model="discount.dialogBatch.form" :rules="discount.dialogBatch.form.rules" :ref="discount.dialogBatch.form.formname" label-width="100px" class="el-form-half etms-dialog-form">
                <el-form-item label="客户：">
                  <el-select size="mini" placeholder="请选择客户" v-model="discount.dialogBatch.form.CustomerId" class="el-width-200" filterable>
                    <el-option v-for="item in customerlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="渠道：">
                  <el-select size="mini" placeholder="请选择渠道" v-model="discount.dialogBatch.form.ChannelId" class="el-width-200" filterable>
                    <el-option v-for="item in channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="版本：">
                  <el-select size="mini" placeholder="请选择折扣版本" v-model="discount.dialogBatch.form.DiscountVersionId" class="el-width-200" filterable>
                    <el-option v-for="item in discount.dialogBatch.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="包裹分类：">
                  <el-select size="mini" placeholder="请选择包裹分类" v-model="discount.dialogBatch.form.ParcelTypeIds" class="el-width-200" filterable multiple collapse-tags>
                    <el-option v-for="item in discount.dialogBatch.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="线路：">
                  <el-select size="mini" placeholder="请选择渠道线路" v-model="discount.dialogBatch.form.ChannelLineIds" class="el-width-200" filterable multiple collapse-tags>
                    <el-option v-for="item in discount.dialogBatch.channellinelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="折扣信息" name="discountinfo">
              <el-table :data="discount.dialogBatch.form.discountlist" :border="true" class="etms-router-list">
                <el-table-column label="序号" type="index" align="center" width="45px"></el-table-column>
                <el-table-column label="分类" align="center">
                  <template slot-scope="scope">
                    <el-select size="mini" v-model="scope.row.PriceTypeId" class="el-width-60">
                      <el-option v-for="item in discount.dialogBatch.pricetypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="起始值(不包含)" align="center" width="120px">
                  <template slot-scope="scope">
                    <el-input size="mini" type="number" v-model="scope.row.StartValue" class="el-width-60"></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="结束值(包含)" align="center">
                  <template slot-scope="scope">
                    <el-input size="mini" type="number" v-model="scope.row.EndValue" class="el-width-60"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="计价分类" align="center">
                  <template slot-scope="scope" align="center">
                    <el-select size="mini" v-model="scope.row.PriceBillingType" class="el-width-70" filterable @change="discountBillingTypeChange(scope.row)">
                      <el-option v-for="item in constant.discountBillingTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="起始价" align="center">
                  <template slot-scope="scope">
                    <el-input size="mini" type="number" v-model="scope.row.StartPrice" class="el-width-60" v-show="scope.row.StartPriceShow"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="百分比" align="center">
                  <template slot-scope="scope">
                    <el-input size="mini" type="number" v-model="scope.row.Percent" class="el-width-60" v-show="scope.row.PercentShow"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="目标分类" align="center">
                  <template slot-scope="scope">
                    <el-select size="mini" v-model="scope.row.TargetPriceTypeId" class="el-width-60" v-show="scope.row.TargetPriceTypeShow">
                      <el-option v-for="item in discount.dialogBatch.pricetypelist" :key="item.value" :value="item.value" :label="item.label" :disabled="item.value === scope.row.PriceTypeId"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="值单位" align="center">
                  <template slot-scope="scope">
                    <el-input size="mini" type="number" v-model="scope.row.ValueUnit" class="el-width-60" v-show="scope.row.ValueUnitShow"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="单价" align="center">
                  <template slot-scope="scope">
                    <el-input size="mini" type="number" v-model="scope.row.UnitPrice" class="el-width-60" v-show="scope.row.UnitPriceShow"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="模式" align="center" width="80px">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.ManualCalcu" label="手动"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column width="50px" align="center">
                  <template slot="header" slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertBarchClick"></el-button>
                  </template>
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteBatchClick(scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
          <span class="dialog-tips">
            {{message.tips.discountBatchSettingTips}}
          </span>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="dialogBatchSubmit">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="discount.dialogImport.dialogtitle" :visible.sync="discount.dialogImport.dialogvisible" :modal-append-to-body="false" center width="700px">
          <el-form :model="discount.dialogImport.form" :rules="discount.dialogImport.form.rules" :ref="discount.dialogImport.form.formname" label-width="100px" class="el-form-half etms-dialog-form">
            <el-form-item label="客户：">
              <el-select size="mini" placeholder="请选择客户" v-model="discount.dialogImport.form.CustomerId" class="el-width-200" filterable>
                <el-option v-for="item in customerlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道：">
              <el-select size="mini" placeholder="请选择渠道" v-model="discount.dialogImport.form.ChannelId" class="el-width-200" filterable>
                <el-option v-for="item in channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="折扣版本：">
              <el-select size="mini" placeholder="请选择折扣版本" v-model="discount.dialogImport.form.DiscountVersionId" class="el-width-200" filterable>
                <el-option v-for="item in discount.dialogImport.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="包裹类型：">
              <el-select size="mini" placeholder="请选择包裹类型" v-model="discount.dialogImport.form.ParcelTypeId" class="el-width-200" filterable>
                <el-option v-for="item in discount.dialogImport.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模版：" prop="Template">
              <el-select size="mini" placeholder="请选择模版进行导入" v-model="discount.dialogImport.form.TemplateId" class="el-width-200" filterable>
                <el-option v-for="item in constant.priceImportTemplates" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="文件" class="clear el-width-fill">
              <el-upload class="upload-demo" ref="upload" :action="constant.openPaths.fileupload" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed" :file-list="discount.dialogImport.form.fileList" :auto-upload="false" list-type="text">
                <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过2mb</div>
              </el-upload>
            </el-form-item>
            <div class="clear"></div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="success" @click="dialogImportSubmit">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog :title="discount.dialogDelete.dialogtitle" :visible.sync="discount.dialogDelete.dialogvisible" :modal-append-to-body="false" center width="700px">
          <el-form :model="discount.dialogDelete.form" :rules="discount.dialogDelete.form.rules" :ref="discount.dialogDelete.form.formname" label-width="120px" class="el-form-half etms-dialog-form">
            <el-form-item label="客户：">
              <el-select size="mini" placeholder="请选择客户" v-model="discount.dialogDelete.form.CustomerId" class="el-width-200" filterable>
                <el-option v-for="item in customerlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道：">
              <el-select size="mini" placeholder="请选择渠道" v-model="discount.dialogDelete.form.ChannelId" class="el-width-200" filterable>
                <el-option v-for="item in channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="折扣版本：">
              <el-select size="mini" placeholder="请选择折扣版本" v-model="discount.dialogDelete.form.DiscountVersionId" class="el-width-200" filterable>
                <el-option v-for="item in discount.dialogDelete.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="包裹类型：">
              <el-select size="mini" placeholder="请选择包裹类型" v-model="discount.dialogDelete.form.ParcelTypeIds" class="el-width-200" filterable multiple collapse-tags>
                <el-option v-for="item in discount.dialogDelete.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道线路：">
              <el-select size="mini" placeholder="请选择渠道线路" v-model="discount.dialogDelete.form.ChannelLineIds" class="el-width-200" filterable multiple collapse-tags>
                <el-option v-for="item in discount.dialogDelete.channellinelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <div class="clear"></div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="success" @click="dialogDeleteSubmit">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activename: 'discount',
      enterpriseaccountlist: [
        { value: '0', label: '黄志刚', SalemanState: true, ServiceState: true, FinanceState: false },
        { value: '1', label: '焦志强', SalemanState: true, ServiceState: true, FinanceState: true },
        { value: '2', label: '肖湘南', SalemanState: true, ServiceState: true, FinanceState: true },
      ],
      customerlist: [
        { label: '广州康美森', value: '0', BindSaleman: '0' },
        { label: '广州凯捷', value: '1', BindSaleman: '1' },
      ],
      channellist: [
        { label: '广州小包', value: '0' }
      ],
      version: {
        search: {
          BindSaleman: '',
          CustomerId: '',
          ChannelId: '',
          VersionName: ''
        },
        versionlist: [
          {
            CustomerId: '0',
            ChannelId: '0',
            DiscountVersionName: '一套折扣',
            EffectStartTime: '2018-10-22 12:11:01',
            EffectEndTime: '2018-12-1',
            State: ''
          }
        ],
        priceversionlist: [
          { label: '一套价格', value: '0' },
        ],
        dialogInsert: {
          dialogtitle: '添加折扣版本',
          dialogvisible: false,
          form: {
            formname: 'insertversion',
            CustomerId: '',
            ChannelId: '',
            PriceVersionId: '',
            DiscountVersionName: '',
            EffectTime: [],
            State: '',
            rules: [],
          },
        },
        dialogCopy: {
          dialogtitle: '复制折扣版本',
          dialogvisible: false,
          DiscountVersionName: '',
          copylist: []
        }
      },
      discount: {
        search: {
          BindSaleman: '',
          CustomerId: '',
          ChannelId: '',
          DiscountVersion: '',
          ParcelTypeId: '',
          ChannelLineId: '',
          linepurposes: ['美国', '英国', '日本']
        },
        pricelist: [
          {
            PriceTypeName: '运费',
            DiscountList: [
              { StartValue: 0, EndValue: 2, DiscountBillingType: '速查', StartPrice: 0, Percent: 0, ValueUnit: 0.5, UnitPrice: '52', ManualCalcu: false }
            ]
          }
        ],
        dialogInsert: {
          dialogtitle: '添加折扣',
          dialogvisible: false,
          discountversionlist: [
            { label: '一套折扣', value: '0' }
          ],
          parceltypelist: [
            { label: '物品', value: '0' },
            { label: '文件', value: '1' },
          ],
          channellinelist: [
            { label: '一区', value: '0' },
            { label: '二区', value: '1' },
          ],
          pricetypelist: [
            { label: '运费', value: '0' },
            { label: '挂号费', value: '1' },
          ],
          form: {
            formname: 'insertdiscount',
            CustomerId: '',
            ChannelId: '',
            DiscountVersionId: '',
            ParcelTypeId: '',
            ChannelLineId: '',
            PriceTypeId: '',
            StartValue: 0,
            EndValue: 2,
            PriceBillingType: '',
            StartPrice: 0,
            StartPriceShow: false,
            Percent: 0,
            PercentShow: false,
            TargetPriceTypeId: '',
            TargetPriceTypeShow: false,
            ValueUnit: 0,
            ValueUnitShow: false,
            UnitPrice: 0,
            UnitPriceShow: false,
            rules: {},
          }
        },
        dialogPass: {
          dialogtitle: '通折设置',
          dialogvisible: false,
          activename: 'baseinfo',
          discountversionlist: [
            { label: '一套折扣', value: '0' }
          ],
          parceltypelist: [
            { label: '物品', value: '0' },
            { label: '文件', value: '1' },
          ],
          channellinelist: [
            { label: '一区', value: '0' },
            { label: '二区', value: '1' },
          ],
          form: {
            formname: 'passdiscount',
            CustomerId: '',
            ChannelId: '',
            DiscountVersion: '',
            ParcelTypeIds: [],
            ChannelLineIds: [],
            discountlist: [],
            rules: {},
          }
        },
        dialogBatch: {
          dialogtitle: '客户折扣批量设置',
          dialogvisible: false,
          activename: 'baseinfo',
          discountversionlist: [
            { label: '一套折扣', value: '0' }
          ],
          parceltypelist: [
            { label: '物品', value: '0' },
            { label: '文件', value: '1' },
          ],
          channellinelist: [
            { label: '一区', value: '0' },
            { label: '二区', value: '1' },
          ],
          pricetypelist: [
            { label: '运费', value: '0' },
            { label: '挂号费', value: '1' },
          ],
          form: {
            formname: 'batchsetting',
            CustomerId: '',
            ChannelId: '',
            DiscountVersionId: '',
            ParcelTypeIds: [],
            ChannelLineIds: [],
            discountlist: [],
            rules: {},
          }
        },
        dialogImport: {
          dialogtitle: '导入客户折扣',
          dialogvisible: false,
          discountversionlist: [
            { label: '一套折扣', value: '0' }
          ],
          parceltypelist: [
            { label: '物品', value: '0' },
            { label: '文件', value: '1' },
          ],
          form: {
            formname: 'importdiscount',
            CustomerId: '',
            ChannelId: '',
            DiscountVersionId: '',
            ParcelTypeId: '',
            TemplateId: '',
            fileList: [],
            rules: {},
          },
        },
        dialogDelete: {
          dialogtitle: '删除客户折扣',
          dialogvisible: false,
          discountversionlist: [
            { label: '一套折扣', value: '0' }
          ],
          parceltypelist: [
            { label: '物品', value: '0' },
            { label: '文件', value: '1' },
          ],
          channellinelist: [
            { label: '一区', value: '0' },
            { label: '二区', value: '1' },
          ],
          form: {
            formname: 'importdiscount',
            CustomerId: '',
            ChannelId: '',
            DiscountVersionId: '',
            ParcelTypeId: '',
            ChannelLineIds: [],
            rules: {},
          },
        }
      }
    }
  },
  methods: {
    insertVersionClick () {
      this.version.dialogInsert.dialogtitle = '添加客户折扣版本'
      this.version.dialogInsert.dialogvisible = true
    },
    searchVersionClick () { },
    formatterCustomerName (row, column) {
      var customer = this.customerlist.filter(item => item.value === row.CustomerId)[0]
      if (customer !== null && customer != undefined) {
        return customer.label
      }
      return ''
    },
    formatterChannelName (row, column) {
      var channel = this.channellist.filter(item => item.value === row.ChannelId)[0]
      if (channel !== null && channel !== undefined) { return channel.label }
      return ''
    },
    formatterEffectTime (row, column) {
      return new Date(row.EffectStartTime.replace(/-/g, '/')).toLocaleString() + ' 至 ' + new Date(row.EffectEndTime.replace(/-/g, '/')).toLocaleString()
    },
    editVersion (index, row) {
      this.version.dialogInsert.dialogtitle = '修改客户折扣版本'
      this.version.dialogInsert.dialogvisible = true
    },
    copyVersion (index, row) {
      this.version.dialogCopy.dialogvisible = true
      this.version.dialogCopy.DiscountVersionName = row.DiscountVersionName
      this.version.dialogCopy.copylist = []
    },
    deleteVersion (index, row) { },
    copyVersionInsert () {
      this.version.dialogCopy.copylist.push({ CustomerId: '', DiscountVersionName: this.version.dialogCopy.DiscountVersionName })
    },
    copyVersionDelete (index) {
      this.version.dialogCopy.copylist.splice(index, 1)
    },
    versionInsertSubmit () { },
    versionCopySubmit () { },
    handleCommand (val) {
      switch (val) {
        case 'passdiscountsetting':
          this.discount.dialogPass.dialogvisible = true
          this.discount.dialogPass.activename = 'baseinfo'
          this.discount.dialogPass.form.discountlist = []
          break
        case 'discountbatchsetting':
          this.discount.dialogBatch.dialogvisible = true
          break
        case 'insertdiscount':
          this.discount.dialogInsert.dialogvisible = true
          this.discount.dialogInsert.dialogtitle = '添加客户折扣'
          break
        case 'importdiscount':
          this.discount.dialogImport.dialogvisible = true
          break
        case 'deletediscount':
          this.discount.dialogDelete.dialogvisible = true
          break
        default:
          break
      }
    },
    editDiscountClick (row) {
      this.discount.dialogInsert.dialogtitle = '修改客户折扣'
      this.discount.dialogInsert.dialogvisible = true
    },
    deleteDiscountClick (row) { },
    insertDiscountPriceTypeChange () {
      this.discount.dialogInsert.form.StartPriceShow = false
      this.discount.dialogInsert.form.PercentShow = false
      this.discount.dialogInsert.form.TargetPriceTypeShow = false
      this.discount.dialogInsert.form.ValueUnitShow = false
      this.discount.dialogInsert.form.UnitPriceShow = false
      switch (this.discount.dialogInsert.form.PriceBillingType) {
        case 0:
          this.discount.dialogInsert.form.StartPriceShow = true
          break
        case 1:
          this.discount.dialogInsert.form.StartPriceShow = true
          this.discount.dialogInsert.form.ValueUnitShow = true
          this.discount.dialogInsert.form.UnitPriceShow = true
          break
        case 2:
        case 3:
          this.discount.dialogInsert.form.ValueUnitShow = true
          this.discount.dialogInsert.form.UnitPriceShow = true
          break
        case 4:
          this.discount.dialogInsert.form.PercentShow = true
          this.discount.dialogInsert.form.TargetPriceTypeShow = true
          break
        case 5:
          this.discount.dialogInsert.form.PercentShow = true
          break
        default:
          break
      }
    },
    dialogInsertSubmit () {

    },
    insertPassClick () {
      this.discount.dialogPass.form.discountlist.push({})
    },
    deletePassClick (index) {
      this.discount.dialogPass.form.discountlist.splice(index, 1)
    },
    dialogPassSubmit () { },
    discountBillingTypeChange (row) {
      row.StartPriceShow = false
      row.PercentShow = false
      row.TargetPriceTypeShow = false
      row.ValueUnitShow = false
      row.UnitPriceShow = false
      switch (row.PriceBillingType) {
        case 0:
          row.StartPriceShow = true
          break
        case 1:
          row.StartPriceShow = true
          row.ValueUnitShow = true
          row.UnitPriceShow = true
          break
        case 2:
        case 3:
          row.ValueUnitShow = true
          row.UnitPriceShow = true
          break
        case 4:
          row.PercentShow = true
          row.TargetPriceTypeShow = true
          break
        case 5:
          row.PercentShow = true
          break
        default:
          break
      }
    },
    insertBarchClick () {
      this.discount.dialogBatch.form.discountlist.push({})
    },
    deleteBarchClick (index) {
      this.discount.dialogBatch.form.discountlist.splice(index, 1)
    },
    dialogBatchSubmit () {
      this.discount.dialogBatch.form.discountlist.forEach((item, index) => {
        alert(item)
      })
    },
    dialogImportSubmit () { },
    dialogDeleteSubmit () { },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/customer_discount_setting.vue